import styled from '@emotion/styled';

export const StyledHelpText = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes['2xs'],
    color: theme.colors.dark70,
    marginTop: theme.spaces[2],
}));
